import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { citiesAPI } from '../utils/api';
import Seo from '../components/Seo';
import { MapPin, ArrowRight } from 'lucide-react';

const CitiesListPage = () => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    citiesAPI.getAll()
      .then((res) => setCities(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gray-50" data-testid="cities-list-page">
      <Seo
        pageKey="cities"
        defaults={{
          title: 'Cities We Serve | Outstation Cabs Across Gujarat – Ecoway Cabs',
          description: 'Explore the cities Ecoway Cabs serves across Gujarat — Dwarka, Somnath, Rajkot, Surat, Vadodara and more. Landmarks, travel details and easy cab booking from Ahmedabad.',
          keywords: 'Gujarat cabs, outstation taxi Gujarat, Ahmedabad to Dwarka, Somnath cab, city taxi Gujarat',
        }}
        path="/cities"
      />
      <section className="bg-gradient-to-r from-blue-900 to-indigo-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-4">Cities We Serve</h1>
          <p className="text-xl text-blue-100 max-w-3xl">Discover key destinations across Gujarat — their landmarks, how to get there from Ahmedabad, and how Ecoway Cabs makes your journey effortless.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <p className="text-center text-gray-500">Loading cities...</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {cities.map((city) => (
                <Link
                  key={city.id}
                  to={`/cities/${city.slug}`}
                  className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow"
                  data-testid={`city-card-${city.slug}`}
                >
                  <div className="h-52 overflow-hidden bg-gray-100">
                    {city.profile_image && (
                      <img
                        src={city.profile_image}
                        alt={city.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    )}
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 text-blue-700 mb-2">
                      <MapPin className="h-4 w-4" />
                      <span className="text-sm font-medium">Gujarat</span>
                    </div>
                    <h3 className="text-xl font-semibold mb-2">{city.name}</h3>
                    <p className="text-gray-600 text-sm line-clamp-3">{city.intro}</p>
                    <span className="inline-flex items-center gap-1 text-blue-700 font-medium mt-4 group-hover:gap-2 transition-all">
                      Explore <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default CitiesListPage;
